import { AttachmentsAction } from 'aos-services/src/core/attachments/actions'
import { AttachmentsState } from 'aos-services/src/core/attachments/state'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { TaskAttachmentGrid } from '../TaskAttachmentGrid'
import { TaskFormField } from '../TaskFormField'

interface TaskAttachmentsFieldProps {
    attachmentsState: AttachmentsState
    attachmentsAction(a: AttachmentsAction): void
}

export const TaskAttachmentsField = ({
    attachmentsState,
    attachmentsAction,
}: TaskAttachmentsFieldProps) => {
    const { t: translate } = useTranslation()

    return (
        <TaskFormField label={translate('form.attachments.label', { ns: 'tasks' })}>
            <TaskAttachmentGrid
                attachmentsState={attachmentsState}
                attachmentsAction={attachmentsAction}
            />
        </TaskFormField>
    )
}
